<div id="content" class="allcp-form" ng-controller="TaskController">
<div ng-include="'modules/company/menus/task_menu.html'"></div>
    <aside 
        class="nano affix sidebar_worker menu-panel" 
        ng-if="menuPanel">
        <div class="addon">
        <p>Hareketler
            <a href="" class="pull-right" ng-click="toggleMenuPanel()">
                <i class="fa fa-times"></i> Kapat
            </a>
        </p>
        <ul>
            <li class="clearfix" ng-repeat="item in data.activities">
                <a href="#" ng-click="getTaskDetails(item.task)">
                <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.worker.profile_photo }}" class="round">

                <div class="legend-info">
                    <span style="font-weight: bold;">{{ item.worker.user.full_name }}</span>
                    <span style="text-decoration: underline">"{{ item.task.description }}"</span> işini
                    
                    <span ng-if="item.type == 'moved'"> 
                            <span style="font-weight: bold;">{{ item.step.name }}</span> olarak değiştirdi.
                    </span>
                    <span ng-if="item.type == 'create'"> 
                        oluşturdu.
                    </span>
                    <span ng-if="item.type == 'edit'"> 
                        düzenledi.
                    </span> <br>    
                    <em class="fs12 mt5"> <i class="fa fa-clock-o"></i> {{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm' }}</em>
                </div>
                </a>
            </li>
        </ul>
        </div>
    </aside>

    <div class="row board"
        id="style-1"
        dragula='"steps-bag"'
        dragula-model="data.steps"
        >
        <h5 class="pn mn mb20 ml15 fs16 mt5">{{ data.project.name }}</h5>
        <div class="list-wrapper container" 
            data="{{ step }}" 
            ng-repeat="step in data.steps">
            <div class="card-header" ng-style="{'background': step.color}">
                <strong class="list-head hint--medium hint--bottom" aria-label="{{ step.name }}">
                    {{ step.name | cut:true:40:' ...'}}
                    <!--
                        <a href="#" data-toggle="modal" data-target="#newTask" ng-click="newOfficeTaskModal(undefined,step)" >
                            <i class="fa fa-plus"></i>
                        </a>
                    -->
                </strong>

                <div class="pull-right edit-task-step">
                    <a href="#" style="cursor: move;">
                        <i class="handle fa fa-arrows fs14"></i>
                    </a>
                    <a href="#" ng-click="editTaskStep(step)" class="ml10 ">
                        <i class="fa fa-pencil fs14"></i>
                    </a>
                    <a href="#" ng-click="deleteTaskStep(step.id,'set')" class="ml10 ">
                        <i class="fa fa-trash fs14"></i>
                    </a>
                    <a href="#" 
                        ng-click="changeNotification(step)" 
                        class="ml10 hint--medium hint--bottom"
                        aria-label="Bu karta bir iş taşındığı zaman size mail ile bildirim gelir.">
                        <i class="fa fa-bell fs14" 
                        ng-class="step.notification ? 'text-danger' : ''"
                        ></i>
                    </a>
                </div>

            </div>

            <div class="list panel panel-primary p10" >

                <div class="list-cards" dragula='"order-bag"'>
                           
                    <div class="list-card p10 text-center new-task">
                        <a href="#" data-toggle="modal" data-target="#newTask" ng-click="newOfficeTaskModal(undefined,step)" >
                            <i class="fa fa-plus fs24"></i>
                        </a>
                   </div>
                    <div class="list-card" 
                        id="{{ order.id }}"
                        ng-repeat="order in data.orders | filter: { status: {id: step.id} } track by $index" 
                        ng-click="getTaskDetails(order)" 
                        >
                        <div class="list-card-details"
                            ng-class="{'low-border' : order.importance == 'low', 'middle-border' : order.importance == 'high-border','class3':order.importance == 'high'}">   
                            <p class="p5 pl10" style="color: #1d364b;">
                                <strong 
                                    ng-if="order.title.length > 0"
                                    style="margin-bottom: 10px !important;display: block;">
                                    {{ order.title }} <br></strong>
                                {{ order.description }}
                            </p>
                            <hr class="mt10 mb10">
                            <div class="bottom p5 pl10 ptn">
                                <span class="badge task-badge">
                                    {{ order.worker.full_name }} 
                                </span>
                                <small class="badge task-badge"> 
                                    <i class="fa fa-clock-o"></i> {{ order.scheduled_time | amDateFormat:'DD MMM, HH:mm' }}
                                </small>
                                <span ng-if="order.comment_count > 0" class="badge task-badge label-success">
                                    <i class="fa fa-comments"></i> {{ order.comment_count }}
                                </span>
                                <span ng-if="order.notification_count > 0" class="badge task-badge label-warning">
                                    <i class="fa fa-bell-o"></i> {{ order.notification_count }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>

<div ng-include="'modules/company/tasks/partials/new_task.html'"></div>
<div ng-include="'modules/company/tasks/partials/task_detail.html'"></div>
<div ng-include="'modules/company/tasks/partials/task_steps.html'"></div>
<div class="modal" id="orderInfo" tabindex="-1" role="dialog" aria-labelledby="orderInfoLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div ng-class="'modal-header alert-' + info.class ">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" style="color:#fff" id="orderInfoLabel">{{ info.title }}!</h4>
            </div>
            <div class="modal-body">
                <p class="fs16"><strong>{{ info.message }}</strong></p>
            </div>
            <div class="modal-footer">
                <button type="button" ng-class="'btn btn-' + info.class " data-dismiss="modal">Tamam</button>
            </div>
        </div>
    </div>
</div>

</div>